import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import FormFields from '../commons/FormFields';
import SetProductPrice from '../commons/SetProductPrice';

class EditNewProductPrice extends React.Component {

  constructor (props) {
    super(props);
    this._isMounted = false; // isMounted React pattern to avoid memory leaks
  }

  componentDidMount () {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render () {
    const { data, onChange, onError } = this.props;
    return (
      <FormFields>
        <SetProductPrice
          data={data}
          onChange={onChange}
          onError={onError}
        />
      </FormFields>
    );
  }
}

const styles = theme => ({});

EditNewProductPrice.propTypes = {
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  data: PropTypes.object,
};

EditNewProductPrice.defaultProps = {
  data: {}
};

export default withStyles(styles, { withTheme: true })(EditNewProductPrice);
